import { Component, OnInit,ViewChild,ElementRef} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '../../service/user.service';
import { LoaderService } from '../../service/loader.service';
import { ChartService } from '../../service/chart.service';
import { BaseComponent } from 'src/app/shared/components/base.component';
import { ChartType, ChartDataSets, ChartOptions,ChartData } from 'chart.js';
@Component({
  selector: 'app-income-per-month-popup',
  templateUrl: './income-per-month-popup.component.html',
  styleUrls: ['./income-per-month-popup.component.scss']
})
export class IncomePerMonthPopupComponent extends BaseComponent implements OnInit {

  @ViewChild('doughnutIncomePerMonth') doughnutIncomePerMonth!: ElementRef;
  chart: any;

  items = [];

  fromDate: any;
  toDate: any;
  reportPeriod: any;
  year: any;
  month: any;
  week: any;
  colorCount:number;
  currentYear=new Date().getFullYear();
  defaultChartData: any= null;
  defaultChartDataLength: number= null;

  // public barChartOptions:any = {
  //   scaleShowVerticalLines: false,
  //   responsive: true
  // };

  public barChartOptions = {
    scales: {
      xAxes: [{ 
        categoryPercentage: 0.7,   // default ~0.8; lower makes bars wider
        barPercentage: 0.9,
        ticks: { beginAtZero: true }
      }]
      // ,
      // yAxes: [{ ticks: { beginAtZero: true } }]
    },
    elements: {
      rectangle: {
        minBarLength: 6,
        borderWidth: 1
      }
    },
    // ... tooltips/hover from above
  };

  chartData: number[]=[];
  public barChartLabels:string[] =[]
  public barChartData:any[] =[];
  public barChartType:string = 'bar';
  public barChartLegend:boolean = false;
  public barChartColors:Array<any> = [];

  public doughnutChartLabels:string[] =[];
  public doughnutChartData:any[] =[];
  public doughnutChartType: ChartType = 'doughnut';
  public doughnutColor: string[] = [];
  public doughnutDatasets: any[];
  public doughnutLabelArray: any[]=[];
  reportfromDate: any;
  reportToDate: any;
  doughnutChartColors:any[] =[];


  constructor( public activeModal: NgbActiveModal
        ,private loaderService: LoaderService
        ,private userService: UserService
        ,private chartService:ChartService) {

          super();

         }

  ngOnInit(): void {
  }
ngAfterViewInit() {
  //console.log("Submit Order Popup ngAfterViewInit")
  // this.CreateChartSelectedDateWise();
   this.CreateChart();


}
  CreateChart()
  {
    console.log("CreateChart",this.defaultChartData);
    
  for (let i = 0; i < this.defaultChartData.length; i++) {
     
          this.barChartColors=[{backgroundColor:'#74acac'}] ;
          this.barChartLabels.push(this.defaultChartData[i].monthName)
          this.chartData.push(this.defaultChartData[i].totalAmount)
    }
    this.barChartData=[{data:this.chartData,label:(new Date()).getFullYear()}];

   
     const subArray: number[] = [];
     const colorArray: any[] = [];
     for (let i = 0; i < this.defaultChartData.length; i++) {
      
          this.doughnutChartLabels.push(this.defaultChartData[i].monthName)          
           subArray.push(this.defaultChartData[i].totalAmount);
          var c=this.chartService.getColors(i+1);
          colorArray.push(c); 
                
    this.doughnutChartColors.push(colorArray);
    }
    this.doughnutChartData.push(subArray);  
    this.doughnutLabelArray.push(this.currentYear);

    if (this.chart) {               
                this.chart.destroy();
              }
              this.chart=
              this.chartService.renderDougNutMultiLayerChart(             
              this.doughnutIncomePerMonth,
              this.doughnutChartLabels,
              this.doughnutChartData,
              this.doughnutChartColors,
              this.doughnutLabelArray,
              true
            );
   
  }

  CreateChartSelectedDateWise()
  {
     console.log("CreateChartSelectedDateWise");

    this.barChartData =[];
    this.chartData=[];
    this.barChartLabels=[];
    this.barChartData=[];
    this.doughnutChartLabels =[];
    this.doughnutChartData=[];
    this.doughnutColor=[];
    this.doughnutDatasets=[];
    this.doughnutLabelArray=[];
    this.loaderService.show();

    //this.chartService.renderChart(this.chart,this.doughnutSubmittedOrder,this.doughnutChartLabels,this.doughnutChartData,this.doughnutColor);
    if(this.items.length>0)
    {
      this.userService.GetDashboardPopupReport(this.items[0]["reportFromDate"],this.items[0]["reportToDate"],this.items[0]["period"],this.items[0]["year"],this.items[0]["month"],"GetIncomePerMonthReport").subscribe(
      ress => {
        this.loaderService.hide();
         if (ress.successed) {
          var data = ress.data;
             //console.log("success");
            
             console.log(data.dashboardPopupDoughChart);
               //#region  Barchart
          const rows = data.dashboardPopupBarChart || [];

          // Decide if we have "simple" (no subColumnName) or "grouped" data
          const hasSubColumns = rows.some(r => r?.subColumnName !== undefined && r?.subColumnName !== null && r?.subColumnName !== '' && r?.subColumnName !== 'undefined');

                if (!hasSubColumns) {
                  // ---- Simple case: only one series, labels are columnName (e.g., years) ----
                  this.barChartLegend = false;

                  this.barChartLabels = rows.map(r => String(r.columnName));
                  const series = rows.map(r => Number(r.columnValue) || 0);

                  this.barChartData = [{
                    data: series,
                    label: this.appTranslateService.getTranslate('Order')
                  }];

                  this.barChartColors = [{
                    backgroundColor: this.chartService.getChartColors(1).base,
                    hoverBackgroundColor: this.chartService.getChartColors(1).hover
                  }];
                } else {
                  // ---- Grouped case: one dataset per year, labels are months (union across all years) ----
                  this.barChartLegend = true;

                  // 1) Build union of months and sort them in calendar order
                  const MONTHS_ORDER = ['January','February','March','April','May','June','July','August','September','October','November','December'];

                  const monthSet = new Set<string>();
                  rows.forEach(r => monthSet.add(String(r.subColumnName)));

                  const labels = Array.from(monthSet).sort((a, b) => MONTHS_ORDER.indexOf(a) - MONTHS_ORDER.indexOf(b));

                  // Assign the global labels once
                  this.barChartLabels = labels;

                  // 2) Group values: Map<year, Map<month, value>>
                  const groups = new Map<string, Map<string, number>>();
                  rows.forEach(r => {
                    const year = String(r.columnName);
                    const month = String(r.subColumnName);
                    const value = Number(r.columnValue) || 0;

                    if (!groups.has(year)) {
                      groups.set(year, new Map<string, number>());
                    }
                    groups.get(year)!.set(month, value);
                  });

                  // 3) Build datasets aligned to the labels
                  this.barChartData = [];
                  this.barChartColors = [];

                  let colorIdx = 0;
                  for (const [year, monthMap] of groups) {
                    const series = labels.map(m => {
                      // Use 0 for missing month (bar with height 0). If you prefer no bar, use `null` instead.
                      return monthMap.get(m) ?? 0;
                    });

                    this.barChartData.push({ data: series, label: year });

                    this.barChartColors.push({
                      backgroundColor: this.chartService.getChartColors(colorIdx).base,
                      hoverBackgroundColor: this.chartService.getChartColors(colorIdx).hover
                    });
                    colorIdx++;
                  }
                  console.log("this.barChartData",this.barChartData);
                }
          //#endregion
             
            //#region Bar chart New Code-- Not working
          
          //   const rows = data?.dashboardPopupBarChart ?? [];
          // console.log("rows.length",rows.length);
          //   // Guard
          //   if (!rows.length) {
          //     this.barChartLegend = false;
          //     this.barChartLabels = [];
          //     this.barChartData = [];
          //     this.barChartColors = [];
          //     return;
          //   }

          //   // Case 1: No subColumnName (single series, simple columns)
          //   // Avoid checking for the *string* "undefined"; check actual undefined/null/empty.
          //   const hasSubColumns = rows.some(r => r.subColumnName !== undefined && r.subColumnName !== null && r.subColumnName !== "");

          //   if (!hasSubColumns) {
          //     this.barChartLegend = false;

          //     // Labels: the columnName values
          //     this.barChartLabels = rows.map(r => String(r.columnName));

          //     // Data: the columnValue values
          //     const values = rows.map(r => r.columnValue);

          //     this.barChartColors = [{ backgroundColor: this.chartService.getColors(1) }];
          //     this.barChartData = [{ data: values, label: String((new Date()).getFullYear()) }];

          //     // If you have a chart reference, update it
          //     // this.chart?.update();
          //     return;
          //   }

          //   // Case 2: We have subColumnName (months) and columnName (years)
          //   this.barChartLegend = true;

          //   // 1) Unique years
          //   const years: string[] = Array.from(
          //     new Set(rows.map(r => String(r.columnName)))
          //   );

          //   // 2) Unique months (union across all rows)
          //   let months: string[] = Array.from(
          //     new Set(rows.map(r => String(r.subColumnName)))
          //   );

          //   // Optional: sort months in calendar order
          //   const MONTH_ORDER = [
          //     "January","February","March","April","May","June",
          //     "July","August","September","October","November","December"
          //   ];
          //   months = months.sort(
          //     (a, b) => MONTH_ORDER.indexOf(a) - MONTH_ORDER.indexOf(b)
          //   );

          //   // 3) Labels are global and set once
          //   this.barChartLabels = months;

          //   // 4) Build one dataset per year, aligned to the months vector
          //   const colors = this.chartService.getColors(years.length);
          //   this.barChartColors = [{ backgroundColor: colors }]; // ng2-charts multi-dataset color set

          //   this.barChartData = years.map((yr, idx) => {
          //     const dataForYear = months.map(m => {
          //       const found = rows.find(r => String(r.columnName) === yr && String(r.subColumnName) === m);
          //       return found ? Number(found.columnValue) : 0; // fill missing month with 0
          //     });

          //     return {
          //       data: dataForYear,
          //       label: yr,
          //       // If you use dataset-level color instead of colors array above, uncomment:
          //       // backgroundColor: colors[idx]
          //     };
          //   });

          //   // this.chart?.update();
          
           //#endregion

             //#region  Barchart old
            // if(data.dashboardPopupBarChart[0].subColumnName === "undefined" || data.dashboardPopupBarChart[0].subColumnName === null){
            // //console.log("if");
            //   this.barChartLegend=false;
            //   this.barChartColors=[{backgroundColor:(this.chartService.getColors(1))}] ;
            //   for (let i = 0; i < data.dashboardPopupBarChart.length; i++) {

            //       this.barChartLabels.push(data.dashboardPopupBarChart[i].columnName)
            //       this.chartData.push(data.dashboardPopupBarChart[i].columnValue)
            //   }

            //   this.barChartData=[{data:this.chartData,label:(new Date()).getFullYear()}];
            // }
            // else
            // {
            //   this.barChartData=[];
            //   console.log("Else");
            //    this.barChartLegend=true;
            //   const distinctColumn = data.dashboardPopupBarChart.filter(
            //     (dashboardPopupBarChart, i, arr) => arr.findIndex(t => t.columnName === dashboardPopupBarChart.columnName) === i
            //   );
            //  //console.log("distinctColumn");
            //  //console.log(distinctColumn);
            //   for (let dc = 0; dc < distinctColumn.length; dc++) {
            //       this.barChartColors=[];
            //       this.barChartLabels=[];
            //       this.chartData=[];

                  
            //       this.colorCount=0;
            //     for (let i = 0; i < data.dashboardPopupBarChart.length; i++) {

            //      if(distinctColumn[dc].columnName === data.dashboardPopupBarChart[i].columnName)
            //      {
            //       this.barChartLabels.push(data.dashboardPopupBarChart[i].subColumnName)
            //       this.chartData.push(data.dashboardPopupBarChart[i].columnValue)
                  
            //            this.colorCount++;
            //      }
            //      //this.barChartColors=[{backgroundColor:(this.getColors(i))}] ;
            //     }
            //     this.barChartData.push({data:this.chartData,label:distinctColumn[dc].columnName});
            //   }
            // }
            //#endregion

             //#region  DoughNut
             const distinctEmployee = data.dashboardPopupDoughChart.filter(
                (dashboardPopupDoughChart, i, arr) => arr.findIndex(t => t.employeeName === dashboardPopupDoughChart.employeeName) === i);
            
             const distinctDate = data.dashboardPopupDoughChart.filter(
                (dashboardPopupDoughChart, i, arr) => arr.findIndex(t => t.date === dashboardPopupDoughChart.date) === i);
              
              this.doughnutChartData = [];
              this.doughnutChartColors = [];

               for (let i = 0; i < distinctDate.length; i++) {
                const subArray: number[] = [];
                const colorArray: any[] = [];
                
                for (let j = 0; j < distinctEmployee.length; j++) {                  

                    if(!this.doughnutChartLabels.some(item => item.includes(distinctEmployee[j].employeeName)))
                    {
                      this.doughnutChartLabels.push(distinctEmployee[j].employeeName);
                    }                     
                     const dataRow = data.dashboardPopupDoughChart.filter(data => data.date === distinctDate[i].date && data.employeeName===distinctEmployee[j].employeeName);
                       
                     if(dataRow.length === 0)
                     {                      
                        subArray.push(0);
                     }
                     else
                     {
                      subArray.push(dataRow[0].value);
                     }
                      var c=this.chartService.getColors(j+1);
                      colorArray.push(c); // Random color
                     
                }
                this.doughnutChartData.push(subArray);
                this.doughnutChartColors.push(colorArray);
                this.doughnutLabelArray.push(distinctDate[i].date);
              }
              
              if (this.chart) {
                
                this.chart.destroy();
              }
              console.log(this.chart);
            this.chart=
            this.chartService.renderDougNutMultiLayerChart(             
              this.doughnutIncomePerMonth,
              this.doughnutChartLabels,
              this.doughnutChartData,
              this.doughnutChartColors,
              this.doughnutLabelArray,
              true
            );

//#endregiond

 
              
         } else {
          this.toastrAlertService.errorToastr(ress.errorMessage);
        }
      },
      error => {
        this.loaderService.hide();
        if (typeof error.error !== "undefined") {
          this.toastrAlertService.errorToastr(this.appTranslateService.getTranslate('generalError'));
        }
      }
    )

    this.barChartData =[];
    this.chartData=[];
    this.barChartLabels=[];
    this.barChartData=[];
    this.doughnutChartLabels =[];
    this.doughnutChartData=[];
    this.items=[];
    this.loaderService.hide();

  }
}
  addItem(newItem: string) { 
  this.items.push(newItem);   
    this.CreateChartSelectedDateWise()
  }

  closeActiveModal(value) {
    this.activeModal.close(true);
  }

    public chartClicked(e:any):void {
      //console.log(e);
    }

  public chartHovered(e:any):void {
      console.log(e);
    }

}
